<div class="modal-header">
  <h5 class="modal-title">
    <em class="fa fa-globe pe-3"></em>
    {{ 'LANGUAGE.TITLE' | translate }}
  </h5>
  <button type="button" class="btn-close btn btn-light" data-bs-dismiss="modal" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body d-grid gap-2">
  <button *ngFor="let lang of getAllLangs()" type="button" class="btn btn-outline-primary" (click)="changeLang(lang)">
    {{ 'LANGUAGE.LANGUAGES.' + lang | translate }}
  </button>
</div>
